import React, { useRef, ReactElement } from "react";
import UseIntersect from "./UseIntersect";

export interface Props {
    /** Your child element that you wish to observe */
    children: JSX.Element;
    /** Callback whenever your item is in view */
    onViewEnter?: () => void;
    /** Callback whenever your item leaves the view */
    onViewExit?: () => void;
    /** on Click Action */
    onClick?: () => void;
    /** Element data test id */
    "data-testid"?: string;
    className?: string;
    options?: object;
    observerClassName?: string;
    observerStyle?: React.CSSProperties;
}

const ElementObserver = (props: Props): ReactElement => {
    const { children, observerClassName, observerStyle, options, onViewEnter, onViewExit, ...otherProps } = props;
    const ref = useRef<HTMLDivElement | null>(null);

    const entry = UseIntersect({ elementRef: ref, options });

    if (entry) {
        if (entry.isIntersecting) {
            if (typeof onViewEnter === "function") {
                onViewEnter();
            }
        } else if (typeof onViewExit === "function") {
            onViewExit();
        }
    }

    return (
        <div {...otherProps}>
            {children}
            <div ref={ref} className={observerClassName} style={observerStyle} />
        </div>
    );
};

export default ElementObserver;
